import { Link } from 'react-router-dom';
import { categories } from '@/mocks/novels';

const categoryBgs = [
  'https://readdy.ai/api/search-image?query=Dynamic%20abstract%20art%20with%20flowing%20golden%20energy%20waves%20on%20deep%20dark%20background%2C%20sense%20of%20rising%20power%20and%20ambition%2C%20cinematic%20lighting%2C%20elegant%20texture%2C%20no%20text%2C%20warm%20tones&width=600&height=400&seq=cat-bg-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Soft%20romantic%20abstract%20art%20with%20flowing%20rose%20gold%20and%20crimson%20petal-like%20shapes%20on%20dark%20background%2C%20elegant%20atmosphere%2C%20warm%20lighting%2C%20no%20text&width=600&height=400&seq=cat-bg-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Luxurious%20abstract%20art%20with%20golden%20geometric%20patterns%20and%20marble%20textures%20on%20dark%20background%2C%20wealth%20and%20power%20vibe%2C%20elegant%20cinematic%20lighting%2C%20no%20text&width=600&height=400&seq=cat-bg-03&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Epic%20dramatic%20abstract%20art%20with%20sharp%20golden%20light%20bursts%20breaking%20through%20dark%20clouds%2C%20powerful%20warrior%20energy%2C%20cinematic%2C%20no%20text&width=600&height=400&seq=cat-bg-04&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Mystical%20abstract%20art%20with%20flowing%20emerald%20and%20golden%20energy%20swirls%20on%20dark%20background%2C%20healing%20and%20martial%20arts%20vibe%2C%20elegant%2C%20no%20text&width=600&height=400&seq=cat-bg-05&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Fantasy%20abstract%20art%20with%20floating%20golden%20ancient%20symbol-like%20shapes%20on%20deep%20mysterious%20dark%20background%2C%20magical%20atmosphere%2C%20no%20text&width=600&height=400&seq=cat-bg-06&orientation=landscape',
];

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            分类浏览
          </h2>
          <p className="text-sm text-foreground-500 mt-2">探索不同类型的都市爽文，找到你的最爱</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.map((cat, index) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative h-52 md:h-56 rounded-lg overflow-hidden cursor-pointer"
            >
              <div
                className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-110"
                style={{ backgroundImage: `url('${categoryBgs[index]}')` }}
              ></div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-black/20 group-hover:from-black/85 transition-all duration-300"></div>

              <div className="absolute inset-0 flex flex-col items-center justify-center p-6 text-center">
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-4 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${cat.icon} text-2xl md:text-3xl text-background-50`}></i>
                </div>
                <h3 className="font-heading text-lg md:text-xl font-bold text-background-50 mb-2">
                  {cat.name}
                </h3>
                <p className="text-xs md:text-sm text-background-50/70 leading-relaxed max-w-xs">
                  {cat.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}